<template>
  <div>
      <v-card-title class="primary--text"><v-btn @click="back" class=" ml-n5 primary--text" text>
        <v-icon>mdi-reply</v-icon></v-btn>General Settings</v-card-title>
          
    <v-timeline
      class="mt-16 elevation-0 ma-4 mt-n2"
      align-top
      elevation="0"
      :dense="$vuetify.breakpoint.smAndDown"
      v-if="
        $store.getters.get_getCustDetails.department_count >= '0' ||
        $store.getters.get_getCustDetails.expense_approver_count >= '0'
      "
    >
      <v-timeline-item
        v-for="(item, i) in timelineitems"
        :key="i"
        :color="item.color"
        :icon="item.icon"
        :label="item.label"
        fill-dot
      >
        <v-card style="width: 1000px" :color="item.color" dark>
          <v-card-title dense class="text-h6">
            {{ item.label }}
          </v-card-title>
          <div>
            <v-card-text class="text-start white text--primary">
              <p>
                {{ item.message }}
              </p>
              <v-btn
                :color="item.btncolor"
                @click="navigatetotab(item)"
                class="mx-0"
                outlined
                dense
              >
                {{ item.btntext }}
              </v-btn>
            </v-card-text>
          </div>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>
<script>
export default {
  data: () => ({
    timelineitems: [
      {
        color: "#2e4152",
        btncolor: "primary lighten-2",
        icon: "mdi-book-variant",
        label: "Step 1(Create Department)",
        message:
          "You need to create departments so that card users belong to the correct   department. This will help you to create department wise Approvers as well as budgets. ",
        btntext: "(click here to create department)",
      },
      {
        color: "#2e4152",
        btncolor: "primary lighten-2",
        icon: "mdi-account-plus",
        label: "Step 2(Create Approver)",
        message:
          "You need to create Approvers before you assign cards to the users.  Approvers, as the name suggests, approve the submitted expenses.",
        btntext: "(Click here to create Approver) ",
      },
    ],
  }),
  methods: {
    navigatetotab(data) {
      if (data.btntext != "Completed") {
        if (data.label == "Step 1(Create Department)") {
          this.$store.commit("SET_dialogcheck", true);
          this.$router.push("/DepartmentMasters");
        } else if (data.label == "Step 2(Create Approver)") {
          this.$store.commit("SET_dialogcheck", true);
          this.$router.push("/AdminAccess");
        }
      }
    },
      back() {
      this.$router.push("/Dashboard");
    },
  },
};
</script>